<div class="righttrack">
  <div [ngClass]="{topright:true, expanded: collapsed}" id="topright">
    <simple-map [mapMode]="'history'"></simple-map>
  </div>
  <div (mousedown)="splitterDown()" class="hor_splitter" id="hor_right_splitter">
      <span></span>
  </div>

  <div [ngClass]="{bottomright:true, collapsed:collapsed}" id="bottomright">
      <div class="btns">
        <div class="btn_tabs">
          <button (click)="this.openTabTrackingRight('table_objects_stat', 1)" [style.display]="usersService.InterfaceIsPermitted(InterfacePermissions.REPORTS) ? '' : 'none'">{{'Statistics'|translate }}</button>
          <button id="track" (click)="this.openTabTrackingRight('table_info', 2)">{{'Track'|translate }}</button>
          <button (click)="this.openTabTrackingRight('table_graphics', 3)">{{'Graphs'|translate }}</button>
          <button (click)="this.openTabTrackingRight('table_data', 4)">{{'Raw data'|translate }}</button>
          <button (click)="this.openTabTrackingRight('table_events', 5)">{{'Events'|translate }}</button>
        </div>
          <div>
              <input type="text" class="dtpickerupleft" value="20.08.2017 10:30 - 28.08.2017 14:05" />
          </div>
          <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
          <button class="btn_img btn_graygray btn_down" (click)="this.collapseRightBottom()"></button>
      </div>
      <div class="bottomrighttables" id="bottomright_tables">
        <app-objects-stat></app-objects-stat>
        <app-track-info></app-track-info>
        <app-short-trend></app-short-trend>
        <app-raw-data-history></app-raw-data-history>
        <app-events-list [trackingMode]="false"></app-events-list>
      </div>
  </div>
</div>
